module.exports = __webpack_public_path__ + "static/img/fish19.4d1e8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish19.png
// module id = z1v3
// module chunks = 0